import React from 'react';
import { ProgressBar } from 'primereact/progressbar';
import { Button } from 'primereact/button';

const FileItem = ({ source, onFileRemoved, onFileDownload, onFileRetry, onFileCancel, translation }) => {

  const cancelFile = () => {
    onFileCancel(source);
  };

  const downloadFile = () => {
    onFileDownload(source);
  };

  const removeFile = () => {
    onFileRemoved(source);
  };

  const retryFile = () => {
    onFileRetry(source);
  };

  return (
    <div className="file-upload-item grid-nogutter flex-nowrap col-12 lg:col-6 flex flex-row justify-content-between gap-3">
      <span class={source.icon}/>
      <div className="flex flex-column gap-1 flex-grow-1">
        <div className="keduall-typography text-14-medium-500 text-default-txt">
          {source.name}
        </div>
        {source.state === 'UPLOADING' && (
          <>
            <ProgressBar value={source.progress} color="#16A34A" className="w-full animated-progress" />
            <div className="keduall-typography text-dark-txt text-12-normal-400">
              {source.progress}% {translation.uploadFileCompleted}
            </div>
          </>
        )}
        {source.state === 'ERROR' && (
          <div className="keduall-typography text-12-normal-400 text-danger-txt">
            {source.errorMessage}
          </div>
        )}
        {source.state === 'UPLOADED' && (
          <div className="keduall-typography text-dark-txt text-12-normal-400">
            {source.lastModifiedDate}
          </div>
        )}
      </div>
      <div className="control flex flex-nowrap gap-2 justify-content-center align-items-center">
        {source.state === 'UPLOADING' && (
          <span className="pi pi-times p-button-rounded text-error-txt cursor-pointer" onClick={cancelFile} />
        )}
        {source.state === 'UPLOADED' && (
          <>
            <span className="pi pi-download p-button-rounded text-success-txt cursor-pointer" onClick={downloadFile} />
            <span className="pi pi-trash p-button-rounded text-error-txt cursor-pointer" onClick={removeFile} />
          </>
        )}
        {source.state === 'ERROR' && (
          <span className="pi pi-trash p-button-rounded text-error-txt cursor-pointer" onClick={removeFile} />
        )}
      </div>
    </div>
  );
};

export default FileItem; 